import { OrderLineCollectionStatus, OrderLineRefundStatus } from '@vista-digital/ocapi-types/v1';
import { isEmptyArray } from '../../../utils/array-utils';
import { getJourneyOrderShowtimeStatus, isActiveJourneyOrderShowtimeStatus, JourneyOrderShowtimeStatus } from './get-journey-order-showtime-status';
import { getSortedJourneyOrderShowtimes } from './journey-utils';
/**
 * The current status of a journey.
 */
export var JourneyStatus;
(function (JourneyStatus) {
    JourneyStatus[JourneyStatus["Active"] = 0] = "Active";
    JourneyStatus[JourneyStatus["Refunded"] = 1] = "Refunded";
    JourneyStatus[JourneyStatus["Expired"] = 2] = "Expired";
    JourneyStatus[JourneyStatus["Collected"] = 3] = "Collected";
})(JourneyStatus || (JourneyStatus = {}));
function getItemOnlyJourneyState(journey) {
    const state = {
        status: JourneyStatus.Active,
        isItemOnly: true,
        nextOrderShowtime: undefined,
        upcomingOrderShowtimes: [],
        refundedOrderShowtimes: [],
        expiredOrderShowtimes: []
    };
    const items = journey.orders
        .map((order) => order.items)
        .reduce((acc, cur) => acc.concat(cur));
    state.status = items.some(item => item.refundStatus === OrderLineRefundStatus.Refunded)
        ? JourneyStatus.Refunded
        : JourneyStatus.Active;
    state.status =
        state.status !== JourneyStatus.Refunded &&
            items.every(item => item.collectionStatus === OrderLineCollectionStatus.Collected)
            ? JourneyStatus.Collected
            : state.status;
    return state;
}
/**
 * Returns the current state of a given journey.
 */
export function getJourneyState(journey) {
    const isItemOnly = journey.orders.every((order) => isEmptyArray(order.showtimes));
    if (isItemOnly)
        return getItemOnlyJourneyState(journey);
    const state = {
        status: JourneyStatus.Active,
        isItemOnly: false,
        nextOrderShowtime: undefined,
        upcomingOrderShowtimes: [],
        refundedOrderShowtimes: [],
        expiredOrderShowtimes: []
    };
    const sortedShowtimes = getSortedJourneyOrderShowtimes(journey);
    sortedShowtimes.forEach(showtime => {
        const showtimeStatus = getJourneyOrderShowtimeStatus(journey, showtime);
        if (isActiveJourneyOrderShowtimeStatus(showtimeStatus)) {
            !state.nextOrderShowtime
                ? (state.nextOrderShowtime = showtime)
                : state.upcomingOrderShowtimes.push(showtime);
        }
        else if (showtimeStatus === JourneyOrderShowtimeStatus.Refunded) {
            state.refundedOrderShowtimes.push(showtime);
        }
        else {
            state.expiredOrderShowtimes.push(showtime);
        }
    });
    state.status =
        state.nextOrderShowtime || state.upcomingOrderShowtimes.length > 0
            ? JourneyStatus.Active
            : state.refundedOrderShowtimes.length > 0 && state.expiredOrderShowtimes.length === 0
                ? JourneyStatus.Refunded
                : JourneyStatus.Expired;
    return state;
}
